<template>
  <v-flex xs12 class="mb-4">
    <div class style="position: relative;">
      <div class="flex-container-space-between vertical-center-container">
        <page-title :routeProps="routeProps"></page-title>
        <div class="text-xs-right">
          <v-btn
            :icon="!$vuetify.breakpoint.smAndUp"
            :color="$store.state.global.pages.rate.color"
            flat
            router
            :to="{name: 'rate'}"
          >
            <v-icon :left="$vuetify.breakpoint.smAndUp">{{$store.state.global.pages.rate.icon}}</v-icon>
            {{$vuetify.breakpoint.smAndUp ? 'Show Rates' : ''}}
          </v-btn>
          <v-btn flat color="grey" @click="toggleView()">
            <v-icon left v-if="listView">list</v-icon>
            <v-icon left v-else>view_module</v-icon>View
          </v-btn>
        </div>
      </div>
      <layout-no-padding>
        <v-flex xs12 sm6 lg3>
          <div class="flex-container-space-between">
            <v-autocomplete
              :prepend-icon="$store.state.global.pages.project.icon"
              :color="$store.state.global.pages.project.color"
              label="Project"
              :items="projects"
              v-model="project"
              item-text="projectName_clientName"
              :clearable="true"
              :rules="projectRules"
              :loading="loadingProjects"
              item-value="id"
            ></v-autocomplete>
            <div class="ml-3" v-if="!!project">
              <v-switch
                :color="$store.state.global.pages.project.color"
                label="Details"
                v-model="showDetails"
              ></v-switch>
            </div>
          </div>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-select
            label="Sort by..."
            :items="sortFactors"
            v-model="sortBy"
            prepend-icon="sort"
            :disabled="listView"
            dense
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-text-field label="Filter by..." v-model="filterBy" prepend-icon="filter_list"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-select label="Type" :items="['Active', 'Request']" v-model="selectedRecordType"></v-select>
        </v-flex>

        <!--CONTROL INFO DISPLAY -->
        <control-info-display :data="projectObj" route="project" v-model="showDetails"></control-info-display>
      </layout-no-padding>

      <v-dialog v-model="addSiteDialog" max-width="500px" @keydown.esc="addSiteDialog = false">
        <v-btn fab dark :color="routeProps.color" class="overlap-fab-site" slot="activator">
          <v-icon dark>{{ isRequest ? 'post_add' : 'add' }}</v-icon>
        </v-btn>
        <!-- ADD SITE COMPONENT-->
        <add-site @close="addSiteDialog = false" :isRequest="isRequest"></add-site>
      </v-dialog>
      <card-divider-split></card-divider-split>
    </div>
  </v-flex>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import SiteValidation from '@/services/validation/siteValidation'
import AddSite from '@/components/sites/addSite'
import ControlInfoDisplay from '@/components/ui/controlInfoDisplay'
import RouteProps from '@/services/mixins/routeProps'

//GET RECORDS
import getSites from '@/services/mixins/getMasterFiles/getSites'
import getProjects from '@/services/mixins/getMasterFiles/getProjects'
export default {
  mixins: [SiteValidation, RouteProps, getSites, getProjects],
  data() {
    return {
      includeInactive: true,
      addSiteDialog: false,
      sortFactors: [
        {
          value: 'id',
          text: 'ID',
        },
        {
          value: 'name',
          text: 'Name',
        },
        {
          value: 'project.name',
          text: 'Project',
        },
        {
          value: 'updatedAt',
          text: 'Updated At',
        },
      ],
    }
  },
  methods: {
    toggleView() {
      this.listView = !this.listView
    },
    sortSites(path1, path2) {
      return this.sites.sort((a, b) => {
        if (a[path] < b[path]) {
          return -1
        } else {
          return 1
        }
      })
    },
  },
  computed: {
    projectObj() {
      if (!!this.project) {
        return this.getObjByPrimaryId(this.project, this.projects)
      } else {
        return null
      }
    },
    isRequest() {
      return this.$store.state.user.userAuthClass.name !== 'Administrator'
    },
    sortBy: Store.getSet({ store: 'sites', prop: 'sortBy' }),
    filterBy: Store.getSet({ store: 'sites', prop: 'filterBy' }),
    listView: Store.getSet({ store: 'sites', prop: 'listView' }),
    project: Store.getSet({ store: 'sites', prop: 'project' }),
    showDetails: Store.getSet({ store: 'sites', prop: 'showDetails' }),
    selectedRecordType: Store.getSet({
      store: 'sites',
      prop: 'selectedRecordType',
    }),
  },
  components: {
    AddSite,
    ControlInfoDisplay,
  },
  watch: {
    projectObj(val) {
      if (!!val) {
        this.showDetails = true
      } else {
        this.showDetails = false
      }
    },
  },
}
</script>

<style scoped>
.overlap-fab-site {
  right: 40px;
  bottom: -17px;
  position: absolute !important;
}
</style>


